<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { PortableTextBlock } from '@sanity/types';
import type { CareersResultsLabels } from '@pkg/types/careers';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string;
    anchorId?: string;
    title: string,
    pretitle: string,
    description?: Array<PortableTextBlock>,
    departmentFieldLabel: string,
    departmentFieldPlaceholder: string,
    countryFieldLabel: string,
    countryFieldPlaceholder: string,
    cityFieldLabel: string,
    cityFieldPlaceholder: string,
    submitButtonLabel: string,
    clearButtonLabel: string,
    resultsLabels: CareersResultsLabels,
    defaultResultsLabels: [{ content: [ { resultsLabels: CareersResultsLabels }] }],
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  title: props.block?.title,
  pretitle: props.block?.pretitle,
  description: props.block?.description,
  departmentFieldLabel: props.block?.departmentFieldLabel,
  departmentFieldPlaceholder: props.block?.departmentFieldPlaceholder,
  countryFieldLabel: props.block?.countryFieldLabel,
  countryFieldPlaceholder: props.block?.countryFieldPlaceholder,
  cityFieldLabel: props.block?.cityFieldLabel,
  cityFieldPlaceholder: props.block?.cityFieldPlaceholder,
  submitButtonLabel: props.block?.submitButtonLabel,
  clearButtonLabel: props.block?.clearButtonLabel,
  resultsLabels: props.block?.resultsLabels,
  defaultResultsLabels: props.block?.defaultResultsLabels[0].content[0].resultsLabels,
  sanityKey: props.block?._key || 'careers',
}));

</script>

<template>
  <component :is="props.config?.innerComponent" :anchor="props.block?.anchorId" v-bind="data"/>
</template>
